import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useParams
} from "react-router-dom";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import FooterInterno from "../../components/Footer/FooterInterno";
import DashboardNavBar from "../../components/Header/DashboardNavBar";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import {
  ObtenerEvaluacionesPersonaCurso
} from "../../services/EvaluacionService";
import { RegistrarEvaluacion } from "../../services/PreguntaService";
import { BuscarUnidadID } from "../../services/UnidadService";
import "./styles/EvaluacionIntro.scss";
import { ObtenerPersonaCurso } from "../../services/UsuarioService";

const EvaluacionIntro = () => {
  const navigate = useNavigate();
  let { IdPersonaCurso } = useParams();
  let { Intento } = useParams();
  let { idUnidad } = useParams();
  let { perfil } = useAlumno();

  const [unidad, setUnidad] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      //let idUnidad = idCursoUsuario;
      BuscarUnidadID({ jwt, idUnidad }).then((data) => {
        setUnidad(data);
      });
    }
  }, [idUnidad]);
  useEffect(() => {
    if(IdPersonaCurso && perfil)
    {
      let jwt = window.localStorage.getItem("jwt");
      ObtenerPersonaCurso({jwt,IdPersonaCurso}).then((data)=>{
        if(data.length == 0)
        {
          navigate("/" + PrivateRoutes.HOME + "/Dashboard")
        }
        else{
          if(data[0].idUsuario != perfil.idUsuario)
          {
            navigate("/" + PrivateRoutes.HOME + "/Dashboard")
          }
        }
      })
    }
  }, [IdPersonaCurso,perfil]);

  useEffect(() => {
    if (IdPersonaCurso && idUnidad && Intento) {
      let jwt = window.localStorage.getItem("jwt");
      let id = IdPersonaCurso;
      ObtenerEvaluacionesPersonaCurso({ jwt, id }).then((data) => {
        let tempEva = data.filter(
          (x) => x.idUnidad === idUnidad && x.intento === Intento
        );
        if (tempEva.length > 0)
          navigate(`/Inicio/CursoInterno/${IdPersonaCurso}`);
      });
    }
  }, [IdPersonaCurso, idUnidad, Intento]);

  const handleSend = () => {
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");
    //localStorage.removeItem("tiempoEvalaucion");
    localStorage.removeItem("502b0ebb62e2");

    let idPersonaCurso = IdPersonaCurso;
    let IdUnidad = idUnidad;
    let intento = Intento;

    let jsonEvaluacion = JSON.stringify(
      {
        idPersonaCurso,
        IdUnidad,
        intento,
      },
      null,
      2
    );

    RegistrarEvaluacion({ jwt, jsonEvaluacion }).then((data) => {
      setLoading(false);
      navigate(
        `/Inicio/Evaluacion/Examen/${IdPersonaCurso}/${data}/${idUnidad}`,{replace:true}
      );
    });
  };
  if (perfil === null) {
    return null;
  }
  return (
    <div className="Evaluacion-introduccion">
      <DashboardNavBar
        titulo={`Evaluación - unidad ${unidad ? unidad.secuencia : ""}`}
        adicional={`Intento: ${Intento && Intento}/2`}
        hideNav
      />
      <div className="content-general-navigation flex align-items-center justify-content-center ">
        <div className="paddingCardIntroEvaluacion">
          <div className="text-xl font-bold mb-5 text-16-mobile">
            Estás a punto de empezar la evaluación de la unidad{" "}
            {unidad && unidad.secuencia}
          </div>
          <div>
            <p className="text-xl font-bold text-16-mobile">Indicaciones:</p>
            <p className="text-base text-12-mobile">
              - Tendrás que responder todas las preguntas y no existen puntos en
              contra
            </p>
            <p className="text-base text-12-mobile">
              - Una vez iniciada la evaluación, cuentas con 45 minutos para
              finalizar
            </p>
            <p className="text-base text-12-mobile">
              - Si sales, el tiempo seguirá corriendo y se calculará la nota de
              acuerdo a las respuestas brindadas
            </p>
            <p className="text-base text-12-mobile">
              - Este es tu{" "}
              {Intento == 2
                ? "segundo y último intento "
                : "primer intento de 2 "}
              ¡Suerte!
            </p>
          </div>
          <div className="flex align-items-center justify-content-center mt-5 button-eva-intro">
            <ButtonZegel
              color="primary"
              label="Comenzar"
              width="100%"
              onClick={handleSend}
              loading={loading}
            ></ButtonZegel>
            {/* <Link
              to={`/Inicio/Evaluacion/Examen/${IdPersonaCurso}/${idEvaluacion}/${idUnidad}`}
              style={{ width: "40%" }}
            ></Link> */}
          </div>
        </div>
      </div>
      <div className="mb-0 mt-4">
        <FooterInterno />
      </div>
    </div>
  );
};

export default EvaluacionIntro;
